@let stromOrGasProducts = this.stromOrGasProducts();
@let fernwaermeProducts = this.fernwaermeProducts();
@let hasStromOrGasProducts = stromOrGasProducts?.length > 0;
@let hasFernwaermeProducts = fernwaermeProducts?.length > 0;

<mwe-address [address]="address()" />

<div class="mt-lg-6 mt-5">
  @if (hasStromOrGasProducts || hasFernwaermeProducts) {
    <h2 data-test="relocation-summary-deregister-title">{{ 'relocation.summary.deregister.title' | translate }}</h2>

    @if (hasStromOrGasProducts) {
      <p
        class="mt-3"
        [innerHTML]="'relocation.summary.deregister.stromGasDescription' | translate: { registrationAt: registrationAt() }"
      ></p>

      <div class="row gy-4">
        @for (product of stromOrGasProducts; track $index) {
          <div class="col-12 col-lg-6">
            <mwe-wizard-product-card-container
              [product]="product"
              [wasInitiallyOrPreviouslyChecked]="true"
              [isReadonly]="true"
              [isDisabled]="true"
              [showTariffClasses]="true"
              [showNumber]="true"
            />
          </div>
        }
      </div>
    }

    @if (hasFernwaermeProducts) {
      <p class="mt-lg-5 mt-4" [innerHTML]="'relocation.summary.deregister.fernwaermeDescription' | translate"></p>

      <div class="row gy-4">
        @for (product of fernwaermeProducts; track $index) {
          <div class="col-12 col-lg-6">
            <mwe-wizard-product-card-container
              [product]="product"
              [wasInitiallyOrPreviouslyChecked]="true"
              [isReadonly]="true"
              [isDisabled]="true"
              [showTariffClasses]="true"
              [showNumber]="true"
            />
          </div>
        }
      </div>
    }

    <h3 class="mt-lg-6 mt-5 mb-4">{{ 'relocation.summary.finalReading.title' | translate }}</h3>

    <mwe-basic-card
      [cardTitle]="'relocation.summary.finalReading.description'"
      [iconClass]="'fa-lightbulb-on'"
      [hasBackground]="true"
      data-test="relocation-summary-finalReading"
    >
      <div class="mt-4">
        @if (hasStromOrGasProducts) {
          <p class="mb-2 text-secondary fw-bold">{{ 'relocation.summary.finalReading.stromGasTitle' | translate }}</p>
          <p class="mb-2">{{ 'relocation.summary.finalReading.stromGasDescription' | translate }}</p>
          <p class="mb-0 text--legal">{{ 'relocation.summary.finalReading.stromGasLegal' | translate }}</p>
        }

        @if (hasStromOrGasProducts && hasFernwaermeProducts) {
          <hr class="my-5" />
        }

        @if (hasFernwaermeProducts) {
          <p class="mb-2 text-secondary fw-bold">{{ 'relocation.summary.finalReading.fernWaermeTitle' | translate }}</p>
          <p class="mb-2">{{ 'relocation.summary.finalReading.fernWaermeDescription' | translate }}</p>
          <p class="mb-0 text--legal">{{ 'relocation.summary.finalReading.fernWaermeLegal' | translate }}</p>
        }
      </div>
    </mwe-basic-card>
  }

  <div class="mb-lg-6 mb-5">
    <h3 class="mt-lg-6 mt-5 mb-4">{{ 'relocation.summary.deregister.invoiceTitle' | translate }}</h3>

    <mwe-basic-card
      [cardTitle]="'summary.personalBilling'"
      [iconClass]="'fa-envelope-open-text'"
      [hasBackground]="true"
      data-test="relocation-summary-deregister-invoice"
    >
      <mwe-products-summary-invoice-old
        [isPaymentInfoVisible]="true"
        [eRechnungInfo]="eRechnungInfo()"
        [paymentIcon]="paymentIcon()"
        [paymentText]="paymentText()"
        [billingAddressTitleText]="'summary.eBillingAddress'"
        [formattedAddress]="formattedAddress()"
        [productCategories]="productCategories()"
        [invoiceInfoAlertMessage]="invoiceInfoAlertMessage()"
        [stromGasMandate]="stromGasMandate()"
        [fernWaermeMandate]="fernWaermeMandate()"
      />
    </mwe-basic-card>
  </div>
</div>
